import {Injectable} from "@angular/core";
import {EmployeeCostDto} from "../../../../../../models/employee-cost-dto";
import {EmploymentCostUtility} from "../../../../common/utils/employee/employment-cost-utility";
import {FilterVO} from "../../../../common/utils/filter/models/filter-vo";


@Injectable({
  providedIn: 'root'
})
export class EmploymentCostRepository {
  totalEmploymentCost: number = 0
  totalEmployeeHours: number = 0;
  private reducedActiveEmploymentCosts: { [id: string]: number } = {}
  private reducedActiveEmployeeHours: { [id: string]: number } = {}
  private reducedDisabledEmploymentCosts: { [id: string]: number } = {}


  constructor() {
  }

  initialize(employeeCosts: { [id: string]: EmployeeCostDto[] }) {
    this.initializeReduced(employeeCosts)
    this.update()
  }

  private initializeReduced(employeeCosts: { [id: string]: EmployeeCostDto[] }) {
    this.reducedActiveEmploymentCosts = EmploymentCostUtility.sumEmploymentCostByEachEvent(employeeCosts)
    this.reducedActiveEmployeeHours = EmploymentCostUtility.sumEmploymentHoursByEvent(employeeCosts)
    this.reducedDisabledEmploymentCosts = {}
  }

  /**
   * Add or remove employee costs from the total costs
   * @param filterVO
   * @param isActive - true if the filter is active, false if the filter is disabled
   * @returns true if the filter was applied successfully, false if the filter could not be applied
   */
  filterEmployeeCost<T>(filterVO: FilterVO<T>, isActive: boolean): boolean {
    if (filterVO.key !== "eventId")
      return false

    if (typeof filterVO.value !== "string" || typeof filterVO.value === "undefined") {
      alert("Ein Fehler ist aufgetreten./n Bitte kontaktieren Sie den Support./n Zeitraum Eventanlyse => addEmployeeCosts")
      return false
    }

    if (isActive) {
      this.reducedActiveEmploymentCosts[filterVO.value as string] = this.reducedDisabledEmploymentCosts[filterVO.value as string]
      // delete
      delete this.reducedDisabledEmploymentCosts[filterVO.value as string]
    } else {
      this.reducedDisabledEmploymentCosts[filterVO.value as string] = this.reducedActiveEmploymentCosts[filterVO.value as string]
      // delete
      delete this.reducedActiveEmploymentCosts[filterVO.value as string]
    }
    return true
  }

  update() {
    this.updateTotalCost()
    this.updateTotalHours()
  }

  private updateTotalCost() {
    this.totalEmploymentCost = Object.values(this.reducedActiveEmploymentCosts).reduce((acc, cost) => acc + cost, 0)
  }

  private updateTotalHours() {
    this.totalEmployeeHours = Object.values(this.reducedActiveEmployeeHours).reduce((acc, hours) => acc + hours, 0)
  }

  getCost(eventId: string) {
    return this.reducedActiveEmploymentCosts[eventId] ?? 0
  }


}
